import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import type React from "react";

type ConfirmType = "delete" | "save";
type Props = {
	actionText?: string;
	cancelText?: string;
	children: React.ReactNode;
	confirmType: ConfirmType;
	disabled?: boolean;
	handleAccept: () => void | Promise<void>;
	handleCancel: () => void;
	isOpen: boolean;
	title?: string;
};

export const ConfirmModal: React.FC<Props> = ({
	isOpen,
	children,
	handleCancel,
	handleAccept,
	title = "確認",
	confirmType,
	actionText,
	cancelText = "キャンセル",
	disabled = false
}: Props) => {
	return (
		<Modalv2 isOpen={isOpen} onClose={handleCancel} size="s">
			<ModalHeader title={title} />
			<ModalBody>{children}</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={handleCancel} type="button" variant="secondary">
						{cancelText}
					</Button>
				}
				rightArea={
					<Button
						disabled={disabled}
						onClick={handleAccept}
						type="button"
						variant={confirmType === "delete" ? "danger" : "primary"}
					>
						{actionText ?? (confirmType === "delete" ? "削除" : "保存")}
					</Button>
				}
			/>
		</Modalv2>
	);
};
